import { clsx, type ClassValue } from 'clsx';

/**
 * Joins class names (clsx). There is no tailwind-merge in this project, so a `className` passed to a ui component is
 * appended, not merged: use it for layout (margins, width, grid placement), not to restyle the component's own
 * padding or colors.
 */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
